/**
 * Formats a timestamp as "5 minutes ago" for recent moments, "Today 3:45 PM"
 * / "Yesterday 8:15 PM" for the same/previous calendar day, and a plain
 * date otherwise. Used by the Registered Devices page for last_seen_at /
 * last_login_at.
 */
export function formatRelativeTime(value) {
  if (!value) return '-';

  const date = new Date(value.replace ? value.replace(' ', 'T') : value);
  if (Number.isNaN(date.getTime())) return '-';

  const now = new Date();
  const diffMs = now - date;
  const diffMinutes = Math.floor(diffMs / 60000);

  if (diffMinutes < 1) return 'الآن';
  if (diffMinutes < 60) return `منذ ${diffMinutes} دقيقة`;

  const diffHours = Math.floor(diffMinutes / 60);
  const time = date.toLocaleTimeString('ar-EG', { hour: 'numeric', minute: '2-digit' });

  const isSameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

  if (isSameDay(date, now)) {
    return diffHours < 1 ? `منذ ${diffMinutes} دقيقة` : `اليوم ${time}`;
  }

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (isSameDay(date, yesterday)) {
    return `أمس ${time}`;
  }

  return date.toLocaleDateString('ar-EG', { year: 'numeric', month: '2-digit', day: '2-digit' }) + ' ' + time;
}
